var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"text-center pt-3"},[_c('b-spinner',{attrs:{"label":"Loading..."}})],1):_c('div',{staticClass:"text-center"},[_c('div',{attrs:{"data-paperform-id":"6pzjfv1e"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }